module.exports = __webpack_public_path__ + "static/media/icon_schedule.00d09932.svg";